<template>
	<b-container fluid>
		<b-row>
			<b-col>
				<card>
					<TripReportTable></TripReportTable>
				</card>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
import TripReportTable from '@/components/Report/TripReportTable.vue';

export default {
	name: 'TripReport',
	components: {
		TripReportTable
	}
};
</script>
